import * as $ from 'jquery';
import * as classNames from 'classnames';
import * as React from 'react';
import style from './dialog.less';
import { SectionStyle } from '../../helpers/SectionStyle';
import '../../css/jquery-ui.css';
import '../../css/jquery-ui-etool.css';
import 'jquery-ui-bundle';
import { consoleTestResultsHandler } from 'tslint/lib/test';
import { OnlineHilfe } from '../helpSystem/OnlineHilfe';

export interface DialogButton {
    title: string;
    disabled?: boolean;
    autoFocus?: boolean;
    onClick(): void;
}

interface ModalDialogProps extends React.ClassAttributes<any> {
    buttons?: ReadonlyArray<DialogButton>;
    title?: string;
    className?: string;
    contentClassName?: string;
    containerId?: string;
    canClose?: boolean;
    hasTitleBar?: boolean;
    closeOnOverlayClick?: boolean;
    displayContentBorder?: boolean;
    isOpen: boolean;
    width?: number | 'auto' | string;
    height?: number | 'auto' | string;
    top?: number;
    left?: number;
    verticalAlignCenter?: boolean;
    fill?: boolean;
    onAfterClose?(): void;
    onAfterOpen?(): void;
    onResize?(size: any): void;
}

interface ModalDialogState {
    idPrefix: string;
}

export default class ModalDialog extends React.Component<ModalDialogProps, ModalDialogState> {
    public static defaultProps: Partial<ModalDialogProps> = {
        // canClose: true,
        hasTitleBar: false,
        closeOnOverlayClick: false,
        displayContentBorder: false,
        buttons: [],
        /*width: 'auto',*/
        height: 'auto',
        fill: false
    };

    constructor(props: ModalDialogProps) {
        super(props);
        //  this.state = { idPrefix: _.uniqueId('modal_dialog_') };
    }

    private canClose: boolean;
    private dialogContainer: HTMLDivElement;
    private lastContainerId: string;

    componentDidMount() {
        const dialogNode: any = $(this.dialogContainer.parentNode);
        this.canClose = typeof this.props.canClose === 'boolean' ? this.props.canClose : true;
        dialogNode.dialog({
            autoOpen: this.props.isOpen,
            closeOnEscape: this.canClose,
            draggable: true,
            resizable: true,
            title: this.props.title,
            width: this.props.width,
            height: this.props.height,
            minHeight: 400,
            modal: false, // Wichtig !!
            // Modal-Parameter = true hindert Eingabe in <input> bei WFormFieldRichText (@tinymce/tinymce-react).
            // Wir müssen dem Parameter false setzen und eine eigene Modal-Div ergänzen.
            dialogClass: this.generateClasses(),
            position: { my: `center ${this.props.verticalAlignCenter ? 'center' : 'top'}`, at: `center ${this.props.verticalAlignCenter ? 'center' : 'top+10'}`, of: window },
            // position: { my: 'center top', at: 'center top+10', of: window },
            open: (event: any, ui: any) => {
                if (this.props.closeOnOverlayClick) {
                    $('.ui-widget-overlay').one('click', () => dialogNode.dialog('close'));
                }
                $('.ui-dialog-titlebar-close').attr('title', '').css({ 'border': 0, 'background-color': 'transparent' });
                $('.ui-dialog-titlebar').css({
                    'background-color': 'gray',
                    'border-bottom': `9px solid gray`,
                    'border-bottom-right-radius': 0,
                    'border-bottom-left-radius': 0
                });
                $('.ui-dialog-title').css({ 'margin': '-7px 0 0 0' });

                if (typeof this.props.top === 'number') {
                    $(`#${event.target.id}`).parent('.ui-dialog').css('top', this.props.top);
                }
                if (typeof this.props.left === 'number') {
                    $(`#${event.target.id}`).parent('.ui-dialog').css('left', this.props.left);
                }

                if (this.props.onAfterOpen) {
                    this.props.onAfterOpen();
                }
            },
            close: () => {
                if (this.props.onAfterClose) {
                    this.props.onAfterClose();
                }
            },
            resizeStop: (event: any, ui: any) => {
                if (this.props.onResize) {
                    this.props.onResize(ui.size);
                }
            }
        });
    }

    componentWillUnmount(): void {
        const dialogNode = $(this.dialogContainer.parentNode);
        ($(dialogNode) as any).dialog('destroy');
    }

    componentDidUpdate(previousProps: ModalDialogProps, previousState: ModalDialogState): void {
        const dialogNode: any = $(this.dialogContainer.parentNode);
        const containerId: string = this.getContainerId();

        if (
            previousProps.title !== this.props.title
            || previousProps.className !== this.props.className
            || this.lastContainerId !== containerId
            || previousProps.canClose !== this.props.canClose
            || previousProps.displayContentBorder !== this.props.displayContentBorder
            || previousProps.buttons !== this.props.buttons
        ) {
            this.canClose = typeof this.props.canClose === 'boolean' ? this.props.canClose : true;
            dialogNode.dialog('option', {
                title: this.props.title,
                dialogClass: this.generateClasses()
            });

            if (this.lastContainerId !== containerId) {
                this.lastContainerId = containerId;
            }
        }

        if (previousProps.isOpen !== this.props.isOpen) {
            // Show or hide dialog
            if (dialogNode.dialog('isOpen') && !this.props.isOpen) {
                dialogNode.dialog('close');
            } else if (!dialogNode.dialog('isOpen') && this.props.isOpen) {
                dialogNode.dialog('open');
            }
        }
    }

    getContainerId(): string {
        if (this.props.containerId) {
            return this.props.containerId;
        }

        return SectionStyle.getCurrentId();
    }

    generateClasses(): string {
        const containerId: string = this.getContainerId();

        return classNames(
            this.props.className, style.outerDialog, style.closeBtn,
            containerId && `cont-${containerId}`,
            this.props.fill && style.fill,
            !this.canClose && style.noClose, this.props.displayContentBorder && style.contentBorder,
            !this.props.hasTitleBar && style.noTitleBar
        );
    }

    render(): JSX.Element {
        return (
            <div ref={(ref) => this.dialogContainer = ref}
                className={classNames(style.modalDialog, this.props.contentClassName)}>
                {this.props.children}
            </div>
        );
    }
}
